(() => {
  const GALLERY_ID = "AllMediaGallery";
  const DISPLAY_ON = "flex"; // keep same as your CSS masonry items

  function getGallery() {
    return document.getElementById(GALLERY_ID);
  }

  function normalizeOptionName(str) {
    return (str || "")
      .toLowerCase()
      .replace(/[:\s]+/g, "") // remove colons + spaces/newlines
      .replace(/-\d+$/g, ""); // remove trailing "-1", "-2"
  }

  function isColorFieldset(fieldset) {
    const legendText = fieldset?.querySelector("legend")?.textContent || "";
    const normLegend = normalizeOptionName(legendText);
    return normLegend.startsWith("farbe") || normLegend.startsWith("color");
  }

  function getInitialSelectedColor() {
    // Works for Dawn swatches/radios
    const fieldsets = document.querySelectorAll("variant-selects fieldset, variant-radios fieldset");
    for (const fs of fieldsets) {
      if (!isColorFieldset(fs)) continue;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked?.value) return checked.value.trim();
    }

    // Works for Dawn dropdown selects (if you ever use them)
    const selects = document.querySelectorAll('variant-selects select, variant-radios select');
    for (const sel of selects) {
      const name = normalizeOptionName(sel.getAttribute("name") || "");
      if (name.includes("farbe") || name.includes("color")) {
        if (sel.value) return sel.value.trim();
      }
    }

    return null;
  }

  function hideAll(items) {
    items.forEach((el) => (el.style.display = "none"));
  }

  function showAllImages(items) {
    items.forEach((el) => (el.style.display = DISPLAY_ON));
  }

  // Show only this color’s images. If none exist, fallback to "all".
  function filterByColor(color) {
    const gallery = getGallery();
    if (!gallery) return;

    const items = Array.from(gallery.querySelectorAll(".media-item"));

    // If no color (edge case), just show all
    if (!color) {
      showAllImages(items);
      return;
    }

    hideAll(items);

    // 1) Show color-matching items (NOT "all")
    let matched = 0;
    items.forEach((el) => {
      const raw = (el.getAttribute("data-colors") || "").trim();
      if (!raw || raw === "all") return;

      const list = raw.split(",").map((s) => s.trim());
      if (list.includes(color)) {
        el.style.display = DISPLAY_ON;
        matched++;
      }
    });

    // 2) Fallback: if no color-specific images, show main ("all") images
    if (matched === 0) {
      items.forEach((el) => {
        const raw = (el.getAttribute("data-colors") || "").trim();
        if (raw === "all") el.style.display = DISPLAY_ON;
      });
    }
    // 🔥 IMPORTANT for mobile slider to update
    document.dispatchEvent(new CustomEvent("vmf:gallery-updated"));
  }

  function isColorChange(target) {
    const fieldset = target.closest("fieldset");
    if (fieldset && isColorFieldset(fieldset)) return true;

    // fallback: target name includes color/color
    const normName = normalizeOptionName(target.getAttribute("name") || "");
    return normName.includes("farbe") || normName.includes("color");
  }

  function getSelectedColorValue(target) {
    // radio input value
    if (target.matches('input[type="radio"]') && target.value) return target.value.trim();

    // select value
    if (target.tagName === "SELECT") return (target.value || "").trim();

    // checked in same fieldset
    const fieldset = target.closest("fieldset");
    const checked = fieldset?.querySelector('input[type="radio"]:checked');
    return checked?.value?.trim() || null;
  }

  // ✅ Initial load: filter to the initially selected color (first available in Dawn)
  document.addEventListener("DOMContentLoaded", () => {
    const initialColor = getInitialSelectedColor();
    filterByColor(initialColor);
  });

  // ✅ Change only when COLOR changes; ignore size/others
  document.addEventListener(
    "change",
    (e) => {
      const t = e.target;
      if (!t) return;

      if (!t.closest("variant-selects") && !t.closest("variant-radios")) return;
      if (!isColorChange(t)) return;

      const color = getSelectedColorValue(t);
      if (!color) return;

      filterByColor(color);
    },
    true
  );
})();
